import { createContext } from 'react';

import { createContextualCan } from '@casl/react';

import MyAbility from '../../utils/ability';

export const AbilityContext = createContext(MyAbility);

export const Can = createContextualCan(AbilityContext.Consumer);